import { render, staticRenderFns } from "./LanguageSelectorAutomatic.vue?vue&type=template&id=07c028d8&"
import script from "./LanguageSelectorAutomatic.vue?vue&type=script&lang=js&"
export * from "./LanguageSelectorAutomatic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports